<template>
    <div class="d-f">
        <div class="normalLinksUser">
            <div class="title">
                {{translation.your_affiliate_link}}
            </div>
            <div class="card-v4 center card--flex">
                <div class="div__cont">
                    <!-- <div
                        class="input--out"
                        v-bind:class="[hideButtonDashboard ? 'width-full-dashboard' : '']"
                    > -->
                    <div
                        class="input--out"
                    >
                        <input
                            type="text"
                            :value="this.generalLinkShare"
                            id="general-share-link"
                            class="general-input"
                        />
                        <div data-clipboard-target="#general-share-link" class="copy" data-labelCopy="copied">
                            <a>{{translation.copy}}</a>
                            <!-- <i class="fa fa-cut"></i> -->
                            <svg fill="white" xmlns:x="http://ns.adobe.com/Extensibility/1.0/" xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/" xmlns:graph="http://ns.adobe.com/Graphs/1.0/" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 125" enable-background="new 0 0 100 100" xml:space="preserve"><metadata><?xpacket begin="&#65279;" id="W5M0MpCehiHzreSzNTczkc9d"?><x:xmpmeta xmlns:x="adobe:ns:meta/" x:xmptk="Adobe XMP Core 5.6-c067 79.157747, 2015/03/30-23:40:42        "/><?xpacket end="w"?></metadata><switch><foreignObject requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/" x="0" y="0" width="1" height="1"/><g i:extraneous="self"><g><g><path fill-rule="evenodd" clip-rule="evenodd" d="M87,7.8H34.2c-2.9,0-5.3,2.4-5.3,5.3v15.8H13c-2.9,0-5.3,2.4-5.3,5.3V87      c0,2.9,2.4,5.3,5.3,5.3h52.8c2.9,0,5.3-2.4,5.3-5.3V71.1H87c2.9,0,5.3-2.4,5.3-5.3V13C92.2,10.1,89.9,7.8,87,7.8z M63.2,84.3      H15.7V36.8h13.2v29c0,2.9,2.4,5.3,5.3,5.3h29V84.3z M84.3,63.2H36.8V15.7h47.5V63.2z"/></g></g></g></switch></svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bt__out">
            <a class="button__general button__general_blue" :href="this.props.urls.rota_office_onboarding_funnel" target="_blank">
                {{this.props.translation.button_onboarding_funnel}}
            </a>
            <!-- <a class="button__general" :href="this.props.urls.rota_office_franchise_rank_new">
                <svg fill="#ffa502" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 125" style="enable-background:new 0 0 100 100;" xml:space="preserve"><path d="M94.4,41.78L73.65,62l4.9,28.56c0.13,0.75-0.18,1.51-0.8,1.96c-0.35,0.25-0.76,0.38-1.18,0.38c-0.32,0-0.64-0.08-0.93-0.23  L50,79.18L24.35,92.67c-0.67,0.35-1.49,0.3-2.11-0.15c-0.62-0.45-0.92-1.21-0.8-1.96L26.35,62L5.6,41.78  c-0.55-0.53-0.74-1.33-0.51-2.05c0.24-0.72,0.86-1.25,1.61-1.36l28.67-4.17L48.21,8.22C48.54,7.54,49.24,7.1,50,7.1  s1.46,0.43,1.79,1.11L64.62,34.2l28.67,4.17c0.75,0.11,1.38,0.64,1.61,1.36S94.94,41.25,94.4,41.78z"/></svg>
                &nbsp;&nbsp;
                {{this.props.translation.button_4_leaderboard}}
            </a> -->
        </div>
    </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
    name: "normal-link-user",
    props: ["props"],
    components: {},
    data() {
        return {
            generalLinkShare: null,
            translation: this.$parent.view.translation.normalLinksUser,
        };
    },
    methods: {
    },
    created() {
        
    },
    mounted() {
        // console.log(this.props);
        this.generalLinkShare = this.props.link_user
            ? this.props.link_user
            : false;
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.d-f {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: stretch;
    column-gap: 0.8rem;
}
.normalLinksUser {
    .title {
        color: white;
        font-weight: bold;
        background: var(--theme-color-primary);
        border-radius: 4px 4px 0px 0px;
        width: 100%;
        padding: .7rem 2.5rem;
        margin: 0 auto;
        text-align: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        font-weight: 700;
    }
    .input--out {
        display: flex;
        justify-content: center;
    }
    input {
        background: #f9f9f9;
        padding: .3rem 1.5rem;
        font-weight: bold;
        color: #707070;
        border: 1px solid #C6C6C6;
        border-radius: 4px 0 0 4px;
    }
    .copy {
        background: var(--theme-color-primary);
        padding: .5rem;
        color: white;
        border-radius: 0 4px 4px 0;
        display: flex;
        align-items: center;
        a {
            color: white;
            text-transform: uppercase;
        }
        svg {
            width: 22px;
            height: 27px;
            margin-left: 7px;
        }
    }
    .card-v4{
        margin-bottom: 0!important;
    }
}
.bt__out {
    text-align: center;

    display: grid;
    // grid-template-columns: 1fr 1fr;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    align-items: stretch;
    align-content: stretch;
    justify-items: stretch;
    justify-content: stretch;
    column-gap: 0.8rem;
    .button__general {
        background: #0cad25;
        font-weight: bold;
        color: white;
        padding: 1.5rem 2rem;
        transition: .3s all ease;
        border-radius: 8px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0!important;
        &:hover {
            box-shadow: 0 0 17px -2px #0cad25;
        }
        svg {
            height: 30px;
        }
    }

    .button__general_blue{
        background-color: #0280f9!important;
        margin: 0!important;
        &:hover {
            box-shadow: 0 0 17px -2px #0280f9;
        }
    }
}
@media (max-width: 980px){
    .d-f {
        grid-template-columns: 1fr;   
    }
    .bt__out {
        margin: 1rem 0;
    }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/normalLinkUser.vue